// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__2Tn05","tabs":"styles_tabs__28m8U","title":"styles_title__17733","actions":"styles_actions__58llv"};